<template lang="">
  <div>
    <Lists
      :liebiaos="liebiaos"
      :totlePage="totlePage"
      :isLiuyan="true"
      @liebiao2="liebiao2"
    ></Lists>
  </div>
</template>
<script>
import { lylist } from "@/api/gxq";

import Lists from "../../components/Lists/Lists";
export default {
  name: "MessageLists",
  components: {
    Lists,
  },
  data() {
    return {
      liebiaos: [],
      totlePage: 45,
    };
  },
  mounted() {
    this.liebiao2();
  },
  methods: {
    async liebiao2(page) {
      const { data } = await lylist({
        page: page ? page - 1 : 0,
      });
      this.liebiaos = data.data;
      this.totlePage = data.pages;
    },
  },
};
</script>
<style lang=""></style>
